import type { TranslationKey } from "../locales";
import { LocalizedError, type LocalizedErrorOptions } from "./localized-error";

/**
 * The caller is known and the row exists, and this caller may not do this to it — only the host
 * organisation approves a booking, only the owner of a crew staffs it. A handler's own 403, with
 * a reason, where the rule verdict `@msuite/citadel`'s `ForbiddenError` gives has none.
 * 403, code `forbidden` — the same code, because the clients treat both as "not yours".
 */
export class NotAllowedError extends LocalizedError {
	readonly status = 403 as const;
	readonly code: string;

	constructor(key: TranslationKey, options?: LocalizedErrorOptions) {
		super(key, options);
		this.name = "NotAllowedError";
		this.code = options?.code ?? "forbidden";
	}
}
